import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { DashboardService } from '../../services/dashboard.service';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent implements OnInit {

  isLoading = true;

  default_heading = 'Discover Your Perfect Career';
  default_sub_heading = 'Take the world’s most-advanced career assessment and find your best-fit career.';
  default_featured_photo = 'https://mindlerimages.imgix.net/home/p-testi4.png';

  informationForm: FormGroup;
  isInformationFormSubmitted: boolean;

  isLargeImage = false;
  isImageUploaded = true;
  uploadedImageName = '';

  loggedInUserDetails;
  displayImageUrl;

  getPartnerDetailsPostData = {
    section: '102'
  };

  saveBtnLabel = 'Saved';

  constructor(private formBuilder: FormBuilder, private dashboardService: DashboardService) { }

  ngOnInit() {

    this.informationForm = this.formBuilder.group({
      type: ['saveData'],
      heading: [this.default_heading, Validators.required],
      sub_heading: [this.default_sub_heading, Validators.required],
      about_us: [''],
      featured_photo: [null],
      profile_evaluation: [false],
      counselling_session: [false],
      overseas_package: [false],
      india_package: [false],
      psychometric_assessment: [false],
      college_recommendation: [false],
      counselling_stream_assessment: [false]
    });

    // TODO - Do we need this validation?
    // about us is mandatory if he uploads a phot
    // this.informationForm.get('about_us').valueChanges.subscribe(data => {
    //   const featured_photo = this.informationForm.get('featured_photo');
    //   if (data.length >= 1) {
    //     featured_photo.setValidators(Validators.required);
    //   }
    //   else {
    //     featured_photo.clearValidators();
    //   }
    //   featured_photo.updateValueAndValidity();
    // });

    this.dashboardService.getPartnerData(this.getPartnerDetailsPostData).subscribe(response => {
      this.isLoading = false;

      if (response.hasOwnProperty('data')) {
        this.informationForm.patchValue({
          heading: response.data.heading,
          sub_heading: response.data.sub_heading,
          about_us: response.data.about_us,
          featured_photo: response.data.featured_photo,
          profile_evaluation: response.data.profile_evaluation,
          counselling_session: response.data.counselling_session,
          overseas_package: response.data.overseas_package,
          india_package: response.data.india_package,
          psychometric_assessment: response.data.psychometric_assessment,
          college_recommendation: response.data.college_recommendation,
          counselling_stream_assessment: response.data.counselling_stream_assessment
        });
      }
      if (this.informationForm.get('featured_photo').value != null) {
        this.displayImageUrl = environment.featured_photo_baseUrl + this.loggedInUserDetails.partner_id + '/' + response.data.featured_photo;
        // Dynamic validation
        const about_us = this.informationForm.get('about_us');
        about_us.setValidators(Validators.required);
        about_us.updateValueAndValidity();
      }
      else {
        this.displayImageUrl = this.default_featured_photo;
      }
    });

    this.loggedInUserDetails = this.dashboardService.decodeToken();
  }

  // getters
  get heading() { return this.informationForm.get('heading'); }
  get sub_heading() { return this.informationForm.get('sub_heading'); }
  get about_us() { return this.informationForm.get('about_us'); }
  get featured_photo() { return this.informationForm.get('featured_photo'); }

  uploadImage(event) {
    if (event.target.files[0].size > 500000) {
      this.isLargeImage = true;
    }
    else {
      this.resetFlag();
      // Dynamic validation
      const about_us = this.informationForm.get('about_us');
      console.log(event.target.files.length);
      if (event.target.files.length >= 1) {
        about_us.setValidators(Validators.required);
      }
      else {
        about_us.clearValidators();
      }
      about_us.updateValueAndValidity();
      //
      this.isLargeImage = false;

      const uploadData = new FormData();
      uploadData.append('featured_photo', event.target.files[0]);
      uploadData.append('type', "imageUpload");

      this.dashboardService.uploadInformationImage(uploadData).subscribe(data => {
        this.uploadedImageName = data.featured_photo;
        this.displayImageUrl = environment.featured_photo_baseUrl + this.loggedInUserDetails.partner_id + '/' + this.uploadedImageName;
      });
    }
    console.log('up name - ', this.uploadedImageName);
    //this.displayImageUrl = environment.featured_photo_baseUrl + this.loggedInUserDetails.partner_id + '/' + this.uploadedImageName;
  }

  informationFormSubmit() {
    this.isInformationFormSubmitted = true;
    console.log(this.informationForm);
    if (this.informationForm.invalid) {
      return;
    }

    this.saveBtnLabel = 'Saving...';

    this.informationForm.patchValue({
      featured_photo: this.uploadedImageName
    });

    this.dashboardService.setInformationDetails(this.informationForm.value).subscribe(data => {
      console.log(data)
      if (data.statusCode == 500 && data.status == false) {
        // this.isErroredOut = data.message;
      }
      else {
        // this.successMessage = data.message;
        this.saveBtnLabel = 'Saved';
      }
    });
  }

  resetFlag() {
    this.saveBtnLabel = 'Save Changes';
  }
}
